export default __webpack_public_path__ + "static/media/Group 1693.5c9aacd5.png";